import { LocalStore, useLocalStore } from 'shared/helpers/Store';
import { useUnlockUtils } from '../unlock/UnlockUtils';

const DEMO_DATA_DISMISSED_KEY = 'pricing-insights-demo-data-dismissed';

export function dismissDemoData() {
  LocalStore.set(DEMO_DATA_DISMISSED_KEY, '1');
}

export function useShouldShowDemoData() {
  const { usedCount } = useUnlockUtils();
  const isDismissed = useLocalStore(DEMO_DATA_DISMISSED_KEY, '');

  return !isDismissed && usedCount === 0;
}
